import { render, staticRenderFns } from "./UserAnalytics.vue?vue&type=template&id=5f24630e&scoped=true"
import script from "./UserAnalytics.vue?vue&type=script&lang=ts"
export * from "./UserAnalytics.vue?vue&type=script&lang=ts"
import style0 from "./UserAnalytics.vue?vue&type=style&index=0&id=5f24630e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f24630e",
  null
  
)

export default component.exports